// In-memory cache for TheSportsDB API responses.
// Prevents hammering the API with duplicate requests across re-renders and navigation.
// Cache lives for the browser session (cleared on full page reload).

import { THESPORTSDB_BASE } from "../data/leaguesConfig";

const cache = new Map();
const CACHE_TTL = 10 * 60 * 1000; // 10 minutes
const inflight = new Map(); // dedup concurrent identical requests

/**
 * Cached fetch wrapper for TheSportsDB v1 API.
 * @param {string} endpoint - e.g. "lookupplayer.php?id=34165220"
 * @returns {Promise<object|null>} parsed JSON or null on error
 */
export async function sportsDbFetch(endpoint) {
  const url = `${THESPORTSDB_BASE}${endpoint}`;

  // Check cache
  const cached = cache.get(url);

  if (cached && Date.now() - cached.ts < CACHE_TTL) {
    return cached.data;
  }

  // Dedup inflight requests for the same URL
  if (inflight.has(url)) {
    return inflight.get(url);
  }

  const promise = fetch(url)
    .then((res) => res.json())
    .then((data) => {
      cache.set(url, { data, ts: Date.now() });
      inflight.delete(url);

      return data;
    })
    .catch(() => {
      inflight.delete(url);

      return null;
    });

  inflight.set(url, promise);

  return promise;
}

/** Clear entire cache (useful if user triggers a manual refresh) */
export function clearSportsDbCache() {
  cache.clear();
}
